
export default {
  props: {
    item: {
      // 传进来的显示数据
      type: Object,
      default: () => {}
    }
  }
}
